import { render, staticRenderFns } from "./archivioVecchiClienti.html?vue&type=template&id=e53fe760&external"
import script from "./ArchivioVecchiClienti.vue?vue&type=script&lang=js"
export * from "./ArchivioVecchiClienti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports